import ApiService from "@/core/services/api.service";
import JwtService from "@/core/services/jwt.service";

const state = {};

const getters = {};

const mutations = {};

const actions = {
	getMarcasBox(context, dados) {
		return new Promise(resolve => {
			if (JwtService.getToken()) {
				ApiService.setHeader();
				ApiService.post("marcas/access/listaBox", dados).then(({ data }) => {
						resolve(data);
				});
			}
		});
	},
	getProdutosMarcas(context, dados) {
		if((!dados.pagina) || (!dados.quantidadePorPagina)) {
				dados.pagina = 1;
				dados.quantidadePorPagina = 25;
		}
		return new Promise(resolve => {
				if (JwtService.getToken()) {
						ApiService.setHeader();
						ApiService.post("marcas/access/listar", dados).then(({ data }) => {
								resolve(data);
						});
				}
		});
	},
	getProdutoMarca(context, dados) {
		return new Promise(resolve => {
				if (JwtService.getToken()) {
						ApiService.setHeader();
						ApiService.post("marcas/access/obter", {ID_PRODUTO_MARCA: dados.id, componente: dados.componente}).then(({ data }) => {
								resolve(data);
						});
				}
		});
	},
	deleteProdutoMarca(context, dados) {
		return new Promise(resolve => {
				if (JwtService.getToken()) {
						ApiService.setHeader();
						ApiService.post("marcas/access/excluir", {ID_PRODUTO_MARCA: dados.id, componente: dados.componente}).then(({ data }) => {
								resolve(data);
						});
				}
		});
	},
	postProdutoMarca(context, dados) {
		return new Promise(resolve => {
				if (JwtService.getToken()) {
						ApiService.setHeader();
						ApiService.post("marcas/access/salvar", dados).then(({ data }) => {
								resolve(data);
						});
				}
		});
	}
};

export default {
    state,
    actions,
    mutations,
    getters
};